// extracted by mini-css-extract-plugin
export default {"productCarousel":"u1-z"};